import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Avatar, Navigation, NavigationItem } from '@appkit4/react-components';

const NavigationSample = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const navList: NavigationItem[] = [
        { name: 'Welcome', prefixIcon: 'hand-wave', divider: true },
        { name: 'PDF to TXT', prefixIcon: 'document-text' },
        { name: 'Convertitore P7M', prefixIcon: 'lockopen-unlock' },
        { name: 'DoCompare', prefixIcon: 'document-multiple' },
        { name: 'DocSimilarity', prefixIcon: 'dial-high' },
    ];

    const routeMap: { [key: string]: string } = {
        'Welcome': '/',
        'PDF to TXT': '/pdftotxt',
        'Convertitore P7M': '/p7mpage',
        'DoCompare': '/DoCompare',
        'DocSimilarity': '/DocSimilarity',
    };

    const activeIndex = navList.findIndex(
        item => item.name && routeMap[item.name] === location.pathname
    );

    const handleItemClick = (event: any, item: NavigationItem) => {
        const target = event.target as HTMLElement;
        if (target.classList.contains('functional-doc-icon')) {
            event.stopPropagation();
            window.open('https://pwcita.sharepoint.com/sites/IT-ADV-IT_AST_DIG_PA_COE/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FIT%2DADV%2DIT%5FAST%5FDIG%5FPA%5FCOE%2FShared%20Documents%2FSviluppi%2F6%2E%20DIG%2FDocument%20Operational%20Toolbox%20%2D%20DOT&viewid=853f9744%2De714%2D4d52%2Db72e%2D8ac987ec1845&p=true&ct=1772100110668&or=OWA%2DNT%2DMail', '_blank');
            return;
        }
        if (item.name && routeMap[item.name]) {
            navigate(routeMap[item.name]);
        }
    };

    // Add documentation icons to navigation items
    useEffect(() => {
        const addDocIcons = () => {
            const navItems = document.querySelectorAll('.ap-navigation-item');

            // Services that need documentation links (skip Welcome)
            const servicesWithDocs = ['PDF to TXT', 'Convertitore P7M', 'DoCompare', 'DocSimilarity'];

            navItems.forEach((item) => {
                const itemText = item.textContent?.trim();

                if (itemText && servicesWithDocs.some(service => itemText.includes(service))) {
                    // Check if icon already added
                    if (!item.querySelector('.functional-doc-icon')) {
                        const icon = document.createElement('span');
                        icon.className = 'Appkit4-icon icon-document-text-outline functional-doc-icon';
                        icon.style.cssText = 'margin-left: auto; font-size: 0.9em; opacity: 0.6; cursor: pointer; padding: 4px;';
                        icon.title = 'Analisi funzionale';

                        // Append to the navigation item
                        item.appendChild(icon);
                    }
                }
            });
        };

        // Add icons after navigation renders
        const timer = setTimeout(addDocIcons, 100);

        return () => clearTimeout(timer);
    }, []);

    const onClickLogo = () => {};

    return (
        <div className="ap-navigation-demo-wrapper">
            <Navigation
                width={320}
                hasFooter={false}
                className="sitedemo"
                showTooltip={true}
                navList={navList}
                onClickLogo={onClickLogo}
                hasHeader={false}
                selectedIndex={activeIndex}
                onClickItem={handleItemClick}
                userTemplate={() => <Avatar className="keyboard-focus" label="VR" disabled={false} role="button" />}
            />
        </div>
    );
}

export default NavigationSample;
